export default __webpack_public_path__ + "static/img_2_1-2b3e282c27f547341b8d9c2d4ba6cca0.jpg";